import type { AppSource, AppVisibility } from '@api/apps';

/** What decides who may edit or copy an app; a catalog entry and a "My apps" summary both provide it. */
export interface AppOwnership {
  readonly source?: AppSource;
  readonly visibility?: AppVisibility | null;
  readonly ownedByMe?: boolean;
}

const isUserApp = (app: AppOwnership): boolean => app.source === 'USER';

export const canEdit = (app: AppOwnership): boolean => isUserApp(app) && app.ownedByMe === true;

/** Built-ins are never copied: their instructions are ours. */
export const canDuplicate = (app: AppOwnership): boolean =>
  isUserApp(app) && (app.ownedByMe === true || app.visibility === 'ORG');
